// extracted by mini-css-extract-plugin
module.exports = {"inner":"NotifyComingSoon_inner___4T9o","ingress":"NotifyComingSoon_ingress__Q9ZP8","inputs":"NotifyComingSoon_inputs__cxKjQ"};